export default __webpack_public_path__ + "static/media/thibaut.d77fa06d.jpg";